import { Col, Row, NavDropdown } from "react-bootstrap";
import { HiOutlineEllipsisVertical } from "react-icons/hi2";
import { Dot, Eye } from "lucide-react";
import { Config } from "@config/config";
import React from "react";
import { useModal } from "@components/ModalContext";
import Details from "../Details";
import FollowSheat from "./FollowSheat";
const Listing = ({ t, mode, data }) => {
  const config = new Config(t);
  const { openModal, setFullscreen, setTitle } = useModal();
  const handleSeeClick = async (item) => {
    setFullscreen(true);
    setTitle("N° : " + item.bookingNumber);
    openModal(<Details bookingNumber={item.bookingNumber} />);
  };

  const handleSheetClick = async (item) => {
    setFullscreen(false);
    setTitle("N° : " + item.bookingNumber);
    openModal(<FollowSheat bookingNumber={item.bookingNumber} mode={mode} />);
  };

  return (
    <>
      {data.map((item, index) => (
        <div
          key={index}
          className={`my-1 p-1 rounded ${
            mode === "dark" ? "bg-dark text-white" : "border bg-white text-dark"
          }`}
        >
          <Row className="align-items-center">
            <Col xs="12" md="2" lg="3" className="my-1">
              <div className="fs-6 fw-light d-flex">
                <span className="me-1">{config.serviceIcon(item.service)}</span>
                {item.bookingNumber}
              </div>
            </Col>
            <Col xs="12" md="3" lg="3" className="my-1">
              <div className="fs-6 fw-light">{item.holder}</div>
            </Col>
            <Col xs="6" md="2" lg="1" className="my-1">
              <div className="fs-6 fw-light">{item.checkin}</div>
            </Col>
            <Col xs="6" md="2" lg="1" className="my-1">
              <div className="fs-6 fw-light">{item.checkout}</div>
            </Col>
            <Col xs="6" md="2" lg="2" className="my-1">
              <div role="button" className="d-flex" title={item.status}>
                <span className={item.status}>
                  <Dot size={30} /> {t(item.status)}
                </span>
              </div>
            </Col>
            <Col xs="6" md="1" lg="1" className="my-1">
              <div className="fs-6 fw-light">
                {item.providerAmountTotal}{" "}
                <span className="text-uppercase">{item.providerCurrency}</span>
              </div>
            </Col>
            <Col
              xs="12"
              md="1"
              lg="1"
              className="product-dropdown d-flex justify-content-end my-1"
            >
              <NavDropdown
                title={
                  <div role="button">
                    <HiOutlineEllipsisVertical size={25} />
                  </div>
                }
                menuVariant="light"
              >
                <div
                  className="px-1 py-2"
                  type="button"
                  onClick={() => handleSeeClick(item)}
                >
                  <span>
                    <Eye size={15} strokeWidth={1.5} />
                  </span>
                  <span className="mx-2">{t("see")}</span>
                </div>
                <div
                  className="px-1  py-2"
                  type="button"
                  onClick={() => handleSheetClick(item)}
                >
                  <span>
                    <Eye size={15} strokeWidth={1.5} />
                  </span>
                  <span className="mx-2">{t("fiche de suivie")}</span>
                </div>
              </NavDropdown>
            </Col>
          </Row>
        </div>
      ))}
    </>
  );
};
export default Listing;
